import React from "react";

const UserCardShimmer = () => {
	return (
			<div className="w-full user-card-modern shadow-lg rounded-xl overflow-hidden mb-4 animate-pulse">
			<div className="flex items-center justify-between px-4 py-3">
				{/* Avatar Placeholder */}
				<div className="w-12 h-12 rounded-full bg-white/40"></div>

				{/* Info Placeholder */}
				<div className="flex-1 ml-4 space-y-2 overflow-hidden">
					<div className="h-4 bg-white/45 rounded w-3/4"></div>
					<div className="h-3 bg-white/30 rounded w-1/2"></div>
				</div>

				{/* Action Buttons Placeholder */}
				<div className="flex gap-2 ml-2">
					<div className="w-6 h-6 rounded bg-white/35"></div>
					<div className="w-6 h-6 rounded bg-white/35"></div>
				</div>
			</div>
		</div>
	);
};

export default UserCardShimmer;
